
Drupal.behaviors.primaryMenu = {
  attach: function (context, settings) {
    once('armed', 'body', context).forEach(el => {
      initFlowbite();
    });

    once('armed', '.burger-button', context).forEach(burgerButton => {
      burgerButton.addEventListener('click', () => {
        burgerButton.querySelectorAll('.tham').forEach(tham => {
          tham.classList.toggle('tham-active');
        })
      });
    });
  },
};